import _ from 'lodash';

export default new class CommodityOfferCreate {
    constructor() {
        this.saveOfferBtn = '.js-saveOffer';
        this.deleteOfferBtn = '.js-deleteRentPointForm';
        this.addOfferBtn = '.js-addRentPoint';
        this.formContainer = '.js-formContainer';
        this.offerForm = '.js-offerForm';
        this.addressSelect = 'select.js-addressSelect';
        this.selectedOptionsArr = [];
        this.adressList = [];
    }

    init() {
        this.bindEvents();
        
        this.adressList = JSON.parse($(this.formContainer).attr('data-addresses'));
        this.removeSelectedAddresses();

        this.renderAddOfferBtn();
        this.renderDeleteOfferBtn();
        this.saveSelectedOptions();
        $(this.addressSelect).niceSelect();
    }

    bindEvents() {
        //save created offers
        $(document).on('click', this.saveOfferBtn, (e) => {
            e.preventDefault();
            this.saveOffers();
        });
        //delete offer
        $(document).on('click', this.deleteOfferBtn, (e) => {
            e.preventDefault();
            this.deleteOffer($(e.target));

            this.reinitCustomSelect();
        });
        //add offer
        $(document).on('click', this.addOfferBtn, (e) => {
            e.preventDefault();

            this.addOffer();
            this.reinitCustomSelect();
        });
        // change available rent points addresses
        $(document).on('change', this.addressSelect, (e) => {
            let formIndex = $(e.target).closest(this.offerForm).index(),
                oldSelectedOptionObj = this.selectedOptionsArr[formIndex];

            this.adressList.push(oldSelectedOptionObj);
            this.saveSelectedOptions();
            this.updateAddressList();
            this.updateRentPointAddressInSelects();

            this.reinitCustomSelect();
        });
    }

    /**
     * Removes from this.adressList, address witch already selected in first offer form
     */
    removeSelectedAddresses() {
        let selectedOption = $(this.addressSelect)[0].options[$(this.addressSelect)[0].selectedIndex],
            selectedAddress = [
                {
                    id: parseInt(selectedOption.value),
                    address: selectedOption.textContent
                }];

        for (let key in this.adressList) {
            if (this.adressList.hasOwnProperty(key)) {
                for (let i = 0; i < selectedAddress.length; i++ ) {
                    if (this.adressList[key].id ===  selectedAddress[i].id) {
                        this.adressList.splice(key, 1);
                    }
                }
            }
        }
    }

    /**
     * Save selected rent points addresses in array this.selectedOptionsArr
     */
    saveSelectedOptions() {
        this.selectedOptionsArr = [];

        let selectArr = $(this.offerForm).find(this.addressSelect);

        for (var i = 0; i < selectArr.length; i++) {
            let $selectedOption = $(selectArr[i]).find('option:selected'),
                selectedOptionVal = $selectedOption[0].value,
                selectedOptionText = $selectedOption[0].text;

            this.selectedOptionsArr.push({'id': parseInt(selectedOptionVal), 'address': selectedOptionText});
        }
    }

    /**
     * Update custom select
     */
    reinitCustomSelect() {
        $(this.addressSelect).niceSelect('update');
    }

    /**
     * Show/hide delete offer btn
     */
    renderDeleteOfferBtn() {
        let $deleteOfferBtn = $(this.deleteOfferBtn);

        if ($(this.offerForm).length == 1) {
            $deleteOfferBtn.hide();
        } else {
            $deleteOfferBtn.show();
        }
    }

    /**
     * Show/hide add offer btn
     */
    renderAddOfferBtn() {
        let $addOfferBtn = $(this.addOfferBtn);

        if (this.adressList.length) {
            $addOfferBtn.show();
        } else {
            $addOfferBtn.hide();
        }
    }

    /**
     * Delete offer
     *
     * @param $deleteBtn - jquery obj, delete offer btn
     */
    deleteOffer($deleteBtn) {
        let $formToDelete = $deleteBtn.closest(this.offerForm),
            $selectToDeleteClone = $formToDelete.find(this.addressSelect).clone();

        $formToDelete.remove();

        this.updateAddressListOnRentPointDelete($selectToDeleteClone);
        this.updateAddressList();
        this.updateRentPointAddressInSelects();
        this.saveSelectedOptions();

        this.renderDeleteOfferBtn();
        this.renderAddOfferBtn();
    }

    /**
     * Add rent point form
     */
    addOffer() {
        if (this.adressList.length) {
            let $forms = $(this.offerForm),
                $form = $($forms[0]),
                $formToAdd = $form.clone();

            this.prepareFormToAdd($formToAdd);
            $(this.formContainer).append($formToAdd);

            this.updateAddressList();
            this.updateRentPointAddressInSelects();
            this.saveSelectedOptions();

            this.renderDeleteOfferBtn();
            this.renderAddOfferBtn();
        }
    }

    /**
     * Clears field in form
     *
     * @param $form - jquery obj, form to add
     */
    prepareFormToAdd($form) {
        let inputs = $form.find('input'),
            textareas = $form.find('textarea'),
            currentSelect = $form.find(this.addressSelect);

        this.makeFieldsEmpty(inputs);
        this.makeFieldsEmpty(textareas);
        this.makeSelectEmpty(currentSelect);

        this.fillSelect(currentSelect);
    }

    /**
     * Update available rent point addresses in rent point addresses selects
     */
    updateRentPointAddressInSelects() {
        let selects = $(this.offerForm).find(this.addressSelect);

        for (var i = 0; i < selects.length; i++) {
            $(selects[i]).find('option:not(:selected)').remove();

            this.fillSelect($(selects[i]));
        }
    }

    /**
     * Fill select by available rent point addresses
     *
     * @param $select - jquery obj of select
     */
    fillSelect($select) {
        for (var i = 0; i < this.adressList.length; i++) {
            let obj = this.adressList[i];
            $select.append(`<option value="${obj.id}">${obj.address}</option>`);
        }
    }

    /**
     * Add address from select to available address array - this.adressList
     *
     * @param $select - jquery obj of select
     */
    updateAddressListOnRentPointDelete($select) {
        let selectedOption = $select.find('option:selected'),
            optionVal = selectedOption[0].value,
            optionText = selectedOption[0].text;

        this.adressList.push({'id': parseInt(optionVal), 'address': optionText});
    }

    /**
     * Remove from this.adressList unavailable addresses from selectedAddressesArr
     */
    updateAddressList() {
        let selects = $(this.addressSelect),
            selectedAddressesArr = [];

        for (let i = 0; i < selects.length; i++) {
            let selectedOption = $(selects[i]).find('option:selected'),
                optionVal = selectedOption[0].value,
                optionText = selectedOption[0].text;

            selectedAddressesArr.push({'id': parseInt(optionVal), 'address': optionText});
        }

        this.adressList = _.pullAllWith(this.adressList, selectedAddressesArr, _.isEqual); //remove selectedAddressesArr obj from this.adressList array
    }

    /**
     * Send ajax, reload page
     */
    saveOffers() {
        let forms = $(this.formContainer).find(this.offerForm),
            data = [];

        for (var i = 0; i < forms.length; i++) {
            data.push(this.prepareFormObject($(forms[i])));
        }
        
        $.request('OfferUpdate::onSave', {
            data: {offers: data},
            loading: '.js-preloaderOverlay',
            complete: function(response) {

                let obResult = response.responseJSON;
                if(!obResult || !obResult.result) {
                    return;
                }

                location.href = obResult.data;
            }
        });
    }

    /**
     * Prepare form object for ajax request
     * @param obForm
     */
    prepareFormObject(obForm) {
        
        return {
            'rent_point_id': obForm.find(this.addressSelect).val(),
            'price': obForm.find('input[name="price"]').val(),
            'quantity': obForm.find('input[name="quantity"]').val(),
            'preview_text': obForm.find('textarea[name="preview_text"]').val(),
        };
    }

    /**
     * Remove all options from select
     *
     * @param select DOM element
     */
    makeSelectEmpty(select) {
        $(select).find('option').remove();
    }

    /**
     * Clear values from inputs, textareas from fieldsArray
     *
     * @param fieldsArray - array of DOM elements of inputs or texatarea
     */
    makeFieldsEmpty(fieldsArray) {
        for (var i = 0; i < fieldsArray.length; i++) {
            $(fieldsArray[i]).val('');
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/add-commodity-offer-form/add-commodity-offer-form.js